module.exports = __webpack_public_path__ + "mo/img/01_Research-Strategy.33dbf351.png";